/*! hp26 v6e — live guards: strip iOS Smart App Banner meta, kill Shopney banner residue,
   stop unexpected homepage scroll-jump on first paint (no hash / no user gesture). */
(function () {
  'use strict';
  if (window.__hp26LiveGuards) return;
  window.__hp26LiveGuards = 1;

  function stripItunesMeta() {
    try {
      document.querySelectorAll('meta[name="apple-itunes-app"]').forEach(function (m) { m.parentNode && m.parentNode.removeChild(m); });
    } catch (e) {}
  }
  function clearHtmlMargin() {
    try {
      var html = document.documentElement, body = document.body;
      if (html) {
        html.style.marginTop = '';
        html.style.top = '';
        html.removeAttribute('data-smartbanner-original-margin-top');
        html.removeAttribute('data-smartbanner-original-top');
      }
      if (body) { body.style.marginTop = ''; }
    } catch (e) {}
  }
  function killSmartbannerDom() {
    clearHtmlMargin();
    try {
      document.querySelectorAll('.js_smartbanner,.smartbanner').forEach(function (el) {
        if (el && el.parentNode) el.parentNode.removeChild(el);
      });
      if (document.documentElement) document.documentElement.style.marginTop = '';
      if (document.body) document.body.style.marginTop = '';
    } catch (e) {}
  }
  stripItunesMeta();
  killSmartbannerDom();
  document.addEventListener('smartbanner.view', function () {
    killSmartbannerDom();
  });
  var mo = new MutationObserver(function () {
    stripItunesMeta();
    if (document.querySelector('.js_smartbanner,.smartbanner,meta[name="apple-itunes-app"]')) {
      stripItunesMeta();
      killSmartbannerDom();
    }
  });
  if (document.documentElement) {
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { try { mo.disconnect(); } catch (e) {} }, 15000);
  var miv = setInterval(clearHtmlMargin, 100);
  setTimeout(function () { clearInterval(miv); }, 4000);
  }

  /* Homepage anti-jump: if something scrolls us down before the visitor interacts, snap back.
     Intentionally skips when location.hash / text-fragments are present. */
  var path = (location.pathname || '/').replace(/\/+$/, '') || '/';
  if (path !== '/') return;
  if (location.hash && location.hash.length > 1) return;

  var touched = false;
  function mark() { touched = true; }
  ['wheel', 'touchstart', 'touchmove', 'keydown', 'mousedown'].forEach(function (t) {
    window.addEventListener(t, mark, { capture: true, passive: true, once: true });
  });

  var born = (window.performance && performance.now) ? performance.now() : Date.now();
  function age() {
    return ((window.performance && performance.now) ? performance.now() : Date.now()) - born;
  }
  function guard() {
    if (touched) return;
    if (age() > 4500) return;
    var y = window.scrollY || window.pageYOffset || 0;
    /* Only correct large unwanted jumps (e.g. to mid-page sections). Tiny shifts from
       sticky header / URL bar / padding reserve are left alone — fighting them feels like zoom. */
    if (y > 480) {
      try { window.scrollTo(0, 0); } catch (e) {}
    }
  }
  var iv = setInterval(guard, 80);
  setTimeout(function () { clearInterval(iv); }, 4800);
  window.addEventListener('load', function () {
    setTimeout(guard, 0);
    setTimeout(guard, 250);
    setTimeout(guard, 800);
  });
})();
